export default "__VITE_ASSET__6e82e47e__"